import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import sprintf from 'sprintf-js';
import { createSelector } from 'reselect';
import Link from 'shared/components/Link';
import { parameterize, parseQueryParams } from 'shared/helper/link-helper';
export var getPaginationUrl = createSelector(function (_ref) {
  var location = _ref.location;
  return location.pathname;
}, function (_ref2) {
  var location = _ref2.location;
  return location.search;
}, function (pathname, query) {
  // We want an encoded query string, where a single % sign is replace with %%,
  // since this is fed through sprintf
  var encodedQueryString = parameterize(parseQueryParams(query, '')).replace(/%/g, '%%');

  // In instances where we have no query string, let's make sure we're replacing
  // strings like ?&page=%(page)s with ?page=%(page)s
  return "".concat(pathname, "?").concat(encodedQueryString, "&page=%(page)s").replace('?&', '?');
});
export var getPaginationPage = createSelector(function (_ref3) {
  var location = _ref3.location;
  return location.search;
}, function (query) {
  return parseInt(parseQueryParams(query, '').page || 1, 10);
});
var pageRange = function pageRange(current, _ref4) {
  var total = _ref4.total,
    _ref4$length = _ref4.length,
    rawLength = _ref4$length === void 0 ? 10 : _ref4$length;
  var length = rawLength;
  if (!total) {
    return [];
  }
  if (length > total) {
    length = total;
  }
  var start = current - Math.floor(length / 2);
  start = Math.max(start, 1);
  start = Math.min(start, 1 + total - length);
  return Array.from({
    length: length
  }, function (el, i) {
    return start + i;
  });
};
var Paginator = function Paginator(_ref5) {
  var pagination = _ref5.pagination,
    url = _ref5.url,
    onPageChange = _ref5.onPageChange,
    updating = _ref5.updating,
    className = _ref5.className;
  var pages = Math.ceil(pagination.numberOfResults / pagination.pageSize);
  var hasNext = pagination.page + 1 <= pages;
  var hasPrev = pagination.page - 1 > 0;
  if (pages <= 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pagination-wrapper ".concat(className)
  }, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
    className: "pagination"
  }, /*#__PURE__*/React.createElement("li", {
    className: "".concat(hasPrev ? 'page-item' : 'page-item disabled')
  }, hasPrev ? /*#__PURE__*/React.createElement(Link, {
    className: "skip-tracking page-link",
    to: sprintf.sprintf(url, {
      page: pagination.page - 1
    }),
    onClick: function onClick() {
      return onPageChange(pagination.page - 1);
    }
  }, "\xAB") : /*#__PURE__*/React.createElement("span", {
    className: "page-link"
  }, "\xAB")), pageRange(pagination.page, {
    total: pages
  }).map(function (page) {
    return /*#__PURE__*/React.createElement("li", {
      key: page,
      className: "".concat(page !== pagination.page ? 'page-item' : 'page-item disabled active')
    }, page !== pagination.page ? /*#__PURE__*/React.createElement(Link, {
      className: "skip-tracking page-link",
      to: sprintf.sprintf(url, {
        page: page
      }),
      onClick: function onClick() {
        return onPageChange(page);
      }
    }, page) : /*#__PURE__*/React.createElement("span", {
      className: "page-link"
    }, page));
  }), /*#__PURE__*/React.createElement("li", {
    className: "".concat(hasNext ? 'page-item' : 'page-item disabled')
  }, hasNext ? /*#__PURE__*/React.createElement(Link, {
    className: "skip-tracking page-link",
    to: sprintf.sprintf(url, {
      page: pagination.page + 1
    }),
    onClick: function onClick() {
      return onPageChange(pagination.page + 1);
    }
  }, "\xBB") : /*#__PURE__*/React.createElement("span", {
    className: "page-link"
  }, "\xBB")), updating ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "mt-2 ms-2 text-muted",
    spin: true
  })) : null)));
};
export default Paginator;